import React, { Component } from 'react';
import { localize } from 'react-localize-redux';
import { Field } from 'redux-form';
import * as validator from 'helpers/Validator';

import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import { colors } from 'helpers/ColorHelper';

import DateRangePicker from 'components/shared/DateRangePicker';
import { CSSTransitionGroup } from 'react-transition-group';

class NoticeEffectiveDateFields extends Component {
  render() {
    const { fields } = this.props;

    return (
      <div>
        <CSSTransitionGroup
          transitionName="add_effective_date_field"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          {fields.map((effectiveDateRange, index) => (
            <div key={index}>
              <div className="row" style={{ marginBottom: '25px' }}>
                <div className="col-xs-11">
                  <Field
                    name={effectiveDateRange}
                    validate={[validator.required]}
                    component={DateRangePicker}
                    disabled={this.props.disabled}
                  />
                </div>
                {!this.props.disabled && (
                  <div className="col-xs-1">
                    <IconButton
                      style={{
                        padding: 0,
                        verticalAlign: 'text-bottom',
                        width: 'none',
                        height: 'none',
                        float: 'right',
                      }}
                      onClick={() => fields.remove(index)}
                    >
                      <DeleteIcon size={24} style={{ padding: 0 }} />
                    </IconButton>
                  </div>
                )}
              </div>
            </div>
          ))}

          {!this.props.disabled && (
            <div className="row" style={{ textAlign: 'center', margin: '20px 0' }}>
              <button
                type="button"
                className="link-button"
                style={{ color: colors.BLUE, textAlign: 'center', fontSize: '16px' }}
                onClick={() => {
                  fields.push();
                }}
              >
                {this.props.translate(
                  'landlordPortal.noticeEffectiveDateFields.clickToAddDateRange'
                )}
              </button>
            </div>
          )}
        </CSSTransitionGroup>
      </div>
    );
  }
}

export default localize()(NoticeEffectiveDateFields);
